import { EventInput } from '@fullcalendar/core';

let eventGuid = 0;
const TODAY_STR = new Date().toISOString().replace(/T.*$/, ''); // YYYY-MM-DD of today

export const INITIAL_EVENTS: EventInput[] = [
  // {
  //   id: createEventId(),
  //   title: 'All-day event',
  //   start: TODAY_STR
  // },
  // {
  //   id: createEventId(),
  //   title: 'Timed event',
  //   start: TODAY_STR + 'T00:00:00',
  //   end: TODAY_STR + 'T03:00:00'
  // },
  // {
  //   id: createEventId(),
  //   title: 'Timed event',
  //   start: TODAY_STR + 'T12:00:00',
  //   end: TODAY_STR + 'T15:00:00'
  // },
  // {
  //   id: createEventId(),
  //   title: '- Worked on PMS Project',
  //   timeFrom: '2025-02-17 10:00:00',
  //   timeTill: '2025-02-17 16:00:00',
  //   className: "hoursCompleted",
  // },
  // {
  //   id: createEventId(),
  //   title: 'Worked on WMS Project',
  //   start: '2025-02-17 16:00:00',
  //   end: '2025-02-17 18:00:00',
  //   className: "hoursCompleted",
  // },
  // {
  //   id: createEventId(),
  //   title: '- Worked on LMD Project',
  //   start: '2025-02-18 10:00:00',
  //   end: '2025-02-18 14:00:00',
  //   className: "halfHoursCompleted",
  // },
  // {
  //   id: createEventId(),
  //   title: '- Worked on PMS Project',
  //   start: '2025-02-16 10:00:00',
  //   end: '2025-02-16 14:00:00',
  //   className: "hoursCompleted",
  // }
];

export function createEventId() {
  return String(eventGuid++);
}